<template>
  <div class="rewardWar">
    <div class="dvDecoration2">
      <div class="dvDecoraBox">
        <dv-decoration-2 class="dvD2" style="width: 200px; height: 10px" />
        <dv-decoration-2 style="width: 200px; height: 10px" />
      </div>
    </div>
    <div class="rewardBox">
      <div class="rewardTitle">奖励公示</div>
      <div class="rewardTable">
        <dv-scroll-board
          :config="rewardData"
          style="width: 100%; height: 110px"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rewardData: {
        header: ['日期', '姓名', '隐患报告或建议内容', '奖励金额'],
        data: [
          ['2025.03.21', '易高根', '线边车间硝饼超量', '120元'],
          ['2025.03.28', '周冬英', '线边车间垃圾未分类', '120元'],
          ['2025.03.30', '黄小英', '工房未按划线管理', '120元'],
          ['2025.04.03', '陈复玲', '关门作业', '120元'],
          ['2025.04.05', '付婷', '部分员工跨域门禁', '120元'],
          ['2025.04.06', '易长生', '运关成品入库超高', '180元'],
          ['2025.04.07', '古国斌', '30号结鞭车间道堵塞', '180元'],
          ['2025.04.08', '揭希元', '24号硝饼中转动态超员', '180元'],
          ['2025.04.15', '古国斌', '电瓶车在生产区超速行驶', '200元']
        ],
        columnWidth: [100, 65, 250, 100],
        waitTime: 1000,
        headerHeight: 20,
        headerBGC: 'rgba(255,255,255,0.2)',
        oddRowBGC: 'rgba(255, 255, 255, 0.1)',
        evenRowBGC: 'rgba(0, 0, 0,0.1)',
        rowNum: 3
      }
    }
  }
}
</script>

<style lang="less" scoped>
.rewardWar {
  width: 100%;
  height: 26%;
  box-sizing: border-box;
  .dvDecoration2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    .dvDecoraBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      .dvD2 {
        margin-bottom: -1px;
        transform: rotate(180deg);
      }
    }
  }
  .rewardBox {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    .rewardTitle {
      width: 20px;
      font-weight: 700;
      font-size: 17px;
      margin-right: -2%;
    }
    .rewardTable {
      width: 90%;
    }
  }
}
</style>>
